import request from '@/utils/request'
/**
 * 获取ai接口调用的token
 * @returns 
 */
export const getAIToken = () => request({
    method:'GET',
    url:'ai/token',
    params:{
        accessKey:'PhaGEbN_E18knd23'
    }
})